// extracted by mini-css-extract-plugin
export default {"row":"List_row__53ZHZ","column":"List_column__5YlEt"};